(() => {
  if (window.LuemasShopifyFormsResponsiveLoaded) return;
  window.LuemasShopifyFormsResponsiveLoaded = true;

  const STYLE_ID = 'luemas-shopify-forms-responsive-style';
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
  const observedShadowRoots = new WeakSet();

  function injectShadowStyles(host) {
    const root = host && host.shadowRoot;
    if (!root || root.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      @media (max-width: 749px) {
        button[class*="_teaser"],
        [class*="_teaser"] button,
        [class*="teaser"] button {
          max-width: min(44vw, 180px) !important;
          min-width: 0 !important;
          min-height: 44px !important;
          padding: 9px 11px !important;
          font-size: 12px !important;
          line-height: 1.2 !important;
          white-space: normal !important;
          overflow-wrap: anywhere !important;
          text-align: center !important;
          box-sizing: border-box !important;
        }

        [class*="_teaser"],
        [class*="teaser"] {
          max-width: min(44vw, 180px) !important;
          box-sizing: border-box !important;
        }

        [class*="_popup"],
        [class*="popup"],
        [class*="_modal"],
        [class*="modal"] {
          max-width: calc(100vw - 24px) !important;
          max-height: calc(100dvh - 24px) !important;
          box-sizing: border-box !important;
        }

        [class*="_content"],
        [class*="content"] {
          max-width: 100% !important;
          box-sizing: border-box !important;
        }
      }

      @media (max-width: 390px) {
        button[class*="_teaser"],
        [class*="_teaser"] button,
        [class*="teaser"] button,
        [class*="_teaser"],
        [class*="teaser"] {
          max-width: min(43vw, 155px) !important;
          font-size: 11px !important;
        }
      }
    `;
    root.appendChild(style);

    if (!observedShadowRoots.has(root)) {
      observedShadowRoots.add(root);
      new MutationObserver(scheduleUpdate).observe(root, { childList: true, subtree: true, attributes: true });
    }
  }

  function teaserButtons() {
    const found = [];
    document.querySelectorAll('shopify-forms-embed').forEach((host) => {
      injectShadowStyles(host);
      const root = host.shadowRoot;
      if (!root) return;
      const buttons = root.querySelectorAll('button[class*="_teaser"], [class*="_teaser"] button, [class*="teaser"] button');
      buttons.forEach((button) => found.push({ host, root, button }));
    });
    return found;
  }

  function findFloatingContainer(button, root) {
    let node = button;
    let fallback = button.parentElement;
    while (node && node !== root.host) {
      if (node instanceof HTMLElement) {
        fallback = node;
        const position = getComputedStyle(node).position;
        if (position === 'fixed') return node;
      }
      node = node.parentElement;
    }
    return fallback;
  }

  function clearPositionStyles(items) {
    items.forEach(({ button, root }) => {
      const floating = findFloatingContainer(button, root);
      if (!floating) return;
      if (floating.dataset.luemasMobilePositioned === 'true') {
        floating.style.removeProperty('left');
        floating.style.removeProperty('right');
        floating.style.removeProperty('bottom');
        floating.style.removeProperty('top');
        floating.style.removeProperty('width');
        floating.style.removeProperty('max-width');
        floating.style.removeProperty('z-index');
        floating.dataset.luemasMobilePositioned = 'false';
      }
    });
  }

  function positionMobileTeasers() {
    const items = teaserButtons().filter(({ button }) => {
      const style = getComputedStyle(button);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });

    if (!MOBILE_QUERY.matches) {
      clearPositionStyles(items);
      return;
    }

    const safeBottom = 'calc(12px + env(safe-area-inset-bottom, 0px))';
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const veryNarrow = viewportWidth <= 340;

    items.forEach(({ button, root }, index) => {
      const floating = findFloatingContainer(button, root);
      if (!floating) return;

      floating.dataset.luemasMobilePositioned = 'true';
      floating.style.setProperty('position', 'fixed', 'important');
      floating.style.setProperty('z-index', '2147483000', 'important');
      floating.style.setProperty('top', 'auto', 'important');

      if (veryNarrow && items.length > 1) {
        floating.style.setProperty('left', '12px', 'important');
        floating.style.setProperty('right', '12px', 'important');
        floating.style.setProperty('width', 'auto', 'important');
        floating.style.setProperty('max-width', 'none', 'important');
        floating.style.setProperty('bottom', `calc(${12 + index * 54}px + env(safe-area-inset-bottom, 0px))`, 'important');
        button.style.setProperty('max-width', '100%', 'important');
        button.style.setProperty('width', '100%', 'important');
      } else {
        const row = Math.floor(index / 2);
        const isLeft = index % 2 === 0;
        floating.style.setProperty('width', 'auto', 'important');
        floating.style.setProperty('max-width', 'min(44vw, 180px)', 'important');
        floating.style.setProperty('bottom', row === 0 ? safeBottom : `calc(${12 + row * 58}px + env(safe-area-inset-bottom, 0px))`, 'important');
        if (isLeft) {
          floating.style.setProperty('left', '10px', 'important');
          floating.style.setProperty('right', 'auto', 'important');
        } else {
          floating.style.setProperty('right', '10px', 'important');
          floating.style.setProperty('left', 'auto', 'important');
        }
      }
    });
  }

  let scheduled = false;
  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      positionMobileTeasers();
    });
  }

  const observer = new MutationObserver(scheduleUpdate);

  function init() {
    document.querySelectorAll('shopify-forms-embed').forEach(injectShadowStyles);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    scheduleUpdate();

    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('orientationchange', scheduleUpdate, { passive: true });
    MOBILE_QUERY.addEventListener?.('change', scheduleUpdate);

    // Shopify Forms can hydrate its shadow DOM after the host is inserted.
    let attempts = 0;
    const hydrationTimer = window.setInterval(() => {
      scheduleUpdate();
      attempts += 1;
      if (attempts >= 20) window.clearInterval(hydrationTimer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
